import Vue from "vue";
// import $ from "jquery";

Vue.directive("simple-date", {
  bind: function(el, arg) {
    if (!arg.value) {
      return;
    }
    el.innerHTML = new Date(arg.value).toLocaleDateString("ru");
  }
});

Vue.directive("hidden", {
  update: function(el, arg) {
    if (!arg.value) {
      el.style.display = "inherit";
      return;
    }
    if (
      arg.value.role === 4 &&
      window.location.href.indexOf("pages/operator") > -1
    ) {
      el.style.display = "none";
    } else {
      el.style.display = "inherit";
    }
  },
  bind: function(el, arg) {
    if (!arg.value) {
      el.style.display = "inherit";
      return;
    }
    if (
      arg.value.role === 4 &&
      window.location.href.indexOf("pages/operator") > -1
    ) {
      el.style.display = "none";
    } else {
      el.style.display = "inherit";
    }
  }
});

Vue.directive("phone-mask", {
  update: function(el, arg) {
    const value = arg.value;
    if (!value) {
      return;
    }
    console.log(value);
  }
  // bind: function(el, arg) {
  //   if (!arg.value) {
  //     return;
  //   }
  //   console.log(el.value);
  //   el.value = "123"
  // }
});
